import React, { useState, useEffect } from 'react'
import { ArrowLeft, Mail, Smartphone, Loader } from 'lucide-react'
import apiService from '../../services/apiService'
import './AuthFlow.scss'
import authService from '../../services/authService'

const VerifyRegistration = ({
  onBack,
  registerData,
  onVerificationSuccess,
}) => {
  const [emailCode, setEmailCode] = useState('')
  const [phoneCode, setPhoneCode] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [timeLeft, setTimeLeft] = useState(900) // 15 minutes

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000)
      return () => clearTimeout(timer)
    }
  }, [timeLeft])

  const handleVerify = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    const connected = await authService.isOnline()
    if (!connected) {
      setError('Votre connexion Internet semble interrompue.')
      setLoading(false)
    } else {
      try {
        const response = await apiService.verifyRegisterCodes(
          registerData.email,
          registerData.phone,
          emailCode,
          phoneCode,
        )

        if (response.success) {
          onVerificationSuccess()
        } else {
          setError(response.error || 'Codes invalides')
        }
      } catch (err) {
        setError('Erreur de connexion. Vérifiez votre connexion internet.')
      } finally {
        setLoading(false)
      }
    }
  }

  const handleResendCodes = async () => {
    setError('')
    setEmailCode('')
    setPhoneCode('')
    setLoading(true)

    const connected = await authService.isOnline()
    if (!connected) {
      setError('Votre connexion Internet semble interrompue.')
      setLoading(false)
    } else {
      try {
        const response = await apiService.requestRegisterCodes(
          registerData.email,
          registerData.phone,
        )

        if (response.success) {
          setTimeLeft(response.data.expiresIn)
          setError('')
        } else {
          setError(response.error)
        }
      } catch (err) {
        setError('Erreur lors du renvoi des codes')
      } finally {
        setLoading(false)
      }
    }
  }

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    return `${mins}:${secs.toString().padStart(2, '0')}`
  }

  return (
    <div className='auth-container'>
      <div className='auth-header'>
        <button onClick={onBack} className='btn-back'>
          <ArrowLeft size={20} />
        </button>
        <h1 className='auth-title'>
          OGC<span style={{ color: 'red' }}>2</span>
          <span style={{ color: 'rgb(255, 255, 42)' }}>2</span>
          <span style={{ color: '#00d700' }}>4</span>
        </h1>
      </div>

      <div className='auth-card'>
        <h2 className='auth-card-title'>Vérification</h2>
        <p className='auth-card-subtitle'>
          Deux codes différents ont été envoyés à votre email et téléphone
        </p>

        <form onSubmit={handleVerify} className='auth-form'>
          <div className='form-field'>
            <label
              style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
            >
              <Mail size={16} /> Code email ({registerData.email})
            </label>
            <input
              type='text'
              value={emailCode}
              onChange={(e) =>
                setEmailCode(e.target.value.replace(/\D/g, '').slice(0, 6))
              }
              placeholder='000000'
              maxLength={6}
              required
              disabled={loading}
              className='code-input'
            />
          </div>

          <div className='form-field'>
            <label
              style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
            >
              <Smartphone size={16} /> Code téléphone ({registerData.phone})
            </label>
            <input
              type='text'
              value={phoneCode}
              onChange={(e) =>
                setPhoneCode(e.target.value.replace(/\D/g, '').slice(0, 6))
              }
              placeholder='000000'
              maxLength={6}
              required
              disabled={loading}
              className='code-input'
            />
          </div>

          {timeLeft > 0 && (
            <div className='code-timer'>
              Codes valides pendant {formatTime(timeLeft)}
            </div>
          )}

          {error && <div className='auth-error'>{error}</div>}

          <button
            type='submit'
            className='btn primary lg full'
            disabled={
              loading || emailCode.length !== 6 || phoneCode.length !== 6
            }
          >
            {loading ? (
              <>
                <Loader size={20} className='btn-icon spinning' />
                Vérification...
              </>
            ) : (
              'Vérifier les codes'
            )}
          </button>

          <button
            type='button'
            onClick={handleResendCodes}
            className='btn secondary lg full'
            disabled={loading || timeLeft > 0}
          >
            Renvoyer les codes
          </button>
        </form>
      </div>

      <div className='auth-footer'>
        Besoin d'aide ? Contactez-nous sur WhatsApp au{' '}
        <span
          onClick={() => {
            window.open('https://wa.me/224621994206', '_blank')
          }}
        >
          +224 621 99 42 06
        </span>
      </div>
    </div>
  )
}

export default VerifyRegistration
